var map = {
	"./template.betgalaxy": 1991,
	"./template.betgalaxy.tsx": 1991,
	"./template.betroyale": 1992,
	"./template.betroyale.tsx": 1992,
	"./template.default": 649,
	"./template.default.tsx": 649,
	"./template.fiestabet": 1993,
	"./template.fiestabet.tsx": 1993,
	"./template.puntcity": 1994,
	"./template.puntcity.tsx": 1994,
	"./template.questbet": 1995,
	"./template.questbet.tsx": 1995,
	"./template.ts": 726,
	"./template.volcanobet": 1996,
	"./template.volcanobet.tsx": 1996,
	"./template.wellbet": 1997,
	"./template.wellbet.tsx": 1997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2290;